<template>
    <v-container fluid class="fill-height" ref="currentContainer">
        <DynamicToolbar
            icon="mdi-truck"
            title="Dispatch v2"
            theme="dark"
            :loading="false"
            :color="moduleColor"
            :reloadPage="true"
        >
            <template #buttons> </template>
            <template #extension> </template>
        </DynamicToolbar>
        <v-row class="fill-height" justify="center" >
            <v-col cols="5" v-if="showLineUp" class="h-100" >
                <OrderLineUp
                    ref="orderLineUp"
                    :moduleColor="moduleColor"
                    :customers="customers"
                    :shiftHeader="shiftHeader"
                    :newRegion="newRegion"
                    @close="showLineUp = !showLineUp"
                    @load-details="openEdit"
                    class="h-100"
                />
            </v-col>

            <v-col :cols="showLineUp ? 7 : 9" class="h-100">
                <Shifts
                    :moduleColor="moduleColor"
                    class="h-100"
                    @newShiftHeader="shiftHeader = $event"
                    ref="Shifts"
                    @regions="regionChange"
                />
            </v-col>
        </v-row>
        <v-btn
            v-if="!showLineUp"
            @click="showLineUp = !showLineUp"
            text
            color="info"
            small
            absolute
            top
            left
            :class="showLineUp ? '' : 'bouncing pulsing'"
        >
            <v-icon>
                mdi-menu-open
            </v-icon>
        </v-btn>
        <edtOrder
            ref="ordersref"
            isModal="true"
            @close="onCloseOrder"
            v-if="$store.state.order.edt"
        />
    </v-container>
</template>

<script>
import axios from 'axios';
import DynamicToolbar from '../../components/Global/Utils/DynamicToolbar.vue';
import OrderLineUp from '../../components/Dispatch/DispatchV2/OrderLineUp.vue';
import Shifts from '../../components/Dispatch/DispatchV2/Shifts.vue';
import edtOrder from '../../components/Modals/Dispatch/Orders/EditOrder.vue';

export default {
    name: 'DispatchV2',
    components: {
        DynamicToolbar,
        OrderLineUp,
        Shifts,
        edtOrder
    },
    data() {
        return {
            newRegion:null,
            showLineUp: true,
            moduleColor: 'upt',
            customers: [],
            shiftHeader: null
        };
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                document.title = 'Dispatch v2';
            }
        }
    },
    mounted() {
        this.getCustomers();
    },
    methods: {
        regionChange: function(region){
            this.newRegion = region;
        },  
        async getCustomers() {
            try {
                const response = await axios.get('customer/active');
                this.customers = response.data.data;
            } catch (error) {
                console.error(error);
            }
        },
        openEdit: function(ord){
            console.log(ord);
            
            this.$store.state.editedOrder.id = ord.OrderID;
            this.$store.state.editedOrder.StationID = ord.StationID;
            this.$store.state.editedOrder.destiny = 1;
            this.$store.state.order.edt = true;
        },
        checkForEleosCurrent: async function(shiftDetail) {
            let resp;
            await axios
                .get('shift-detail/eleos-current-shift/' + shiftDetail)
                .then(response => {
                    console.log('checkForEleosCurrent: ', response.data);
                    resp = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                });

            return resp;
        },
        onCloseOrder: function(shDetail){
            console.log(shDetail,'here');
            this.$refs.Shifts.onEditOrderClose(shDetail);
        },
        onEditOrderClose: async function(shDetail) {
            console.log(shDetail);
            let index = this.shiftDetails.indexOf(shDetail);
            let eleosCurrent = await this.checkForEleosCurrent(shDetail);

            await this.loadOrderShift(shDetail, index, 'onEditOrderClose');
            console.log(this.shifts[index].SentMailCounter);
            if (
                this.shifts[index].SentMailCounter > 0 &&
                this.shifts[index].DriverEleosApp == 1 &&
                eleosCurrent == 1
            ) {
                console.log('Dentro del if');
                let newShiftInfoDispatch = this.buildNewShiftInfoDispatch(
                    shDetail,
                    index
                );
                await this.getCurrentShiftInfo(
                    shDetail,
                    index,
                    newShiftInfoDispatch
                );
            }
        },
        getCurrentShiftInfo: async function(
            shDetail,
            index,
            newShiftInfoDispatch
        ) {
            let emailCounter = this.shifts[index].SentMailCounter;

            if (emailCounter > 0) {
                this.$store.state.isLoading = true;
                var str = this.$store;
                await axios
                    .get('shift-diff-checker/current-info/' + shDetail, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(async response => {
                        let currentShiftInfoDispatch = response.data;
                        console.log(
                            'CurrentShiftInfoDispatch',
                            currentShiftInfoDispatch
                        );
                        this.$store.state.isLoading = false;
                        await this.getProductsByOrder(
                            emailCounter,
                            index,
                            newShiftInfoDispatch,
                            currentShiftInfoDispatch
                        );
                    })
                    .catch(function(error) {
                        console.log(error);
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'Something is wrong. Please contact the administrator.'
                        });
                        this.$store.state.isLoading = false;
                    });
            } else {
                console.log(emailCounter);
                await this.getProductsByOrder(
                    emailCounter,
                    index,
                    newShiftInfoDispatch,
                    {}
                );
            }
        },
        getProductsByOrder: async function(
            emailCounter,
            index,
            newShiftInfoDispatch,
            currentShiftInfoDispatch
        ) {
            var str = this.$store;

            console.log('Dentro de getProductsByOrder', newShiftInfoDispatch);
            for (let ord of newShiftInfoDispatch.ordersShiftData) {
                //console.log(ord.generalOrderData.OrderID)

                await axios
                    .get('order-detail/order/' + ord.generalOrderData.OrderID, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        let productsByOrder = response.data.data;
                        console.log('productsByOrder', productsByOrder);
                        ord.orderProductData = [];
                        for (let prd of productsByOrder) {
                            let {
                                Product,
                                ProductID,
                                ProductCode,
                                DispatchedQuantity
                            } = prd;
                            ord.orderProductData.push({
                                Product,
                                ProductID,
                                ProductCode,
                                DispatchedQuantity
                            });
                        }

                        // Ordenamiento tipo burbuja por ProductID
                        let l = ord.orderProductData.length;
                        let aux;

                        for (let i = 1; i < l; i++) {
                            for (let prd = 0; prd < l - i; prd++) {
                                if (
                                    ord.orderProductData[prd].ProductID >
                                    ord.orderProductData[prd + 1].ProductID
                                ) {
                                    aux = ord.orderProductData[prd];
                                    ord.orderProductData[prd] =
                                        ord.orderProductData[prd + 1];
                                    ord.orderProductData[prd + 1] = aux;
                                }
                            }
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'Something is wrong. Please contact the administrator.'
                        });
                    });
            }

            if (emailCounter > 0) {
                this.generateDiffs(
                    index,
                    newShiftInfoDispatch,
                    currentShiftInfoDispatch
                );
            } else {
                console.log('No se ha hecho el primer envío.');
            }
            console.log('NewShiftInfo', newShiftInfoDispatch);
        },
        buildNewShiftInfoDispatch: function(shDetail, index) {
            console.log(shDetail, index);
            let newShiftInfoDispatch = {};
            let shift = this.shifts[index];

            // Preparation of the new shift info data
            let {
                Driver,
                DriverID,
                ShiftDate,
                Shift,
                ShiftDetail,
                Truck,
                TruckID,
                Trailer,
                TrailerID,
                ReplacementUnit,
                Yard,
                TruckYard,
                SentMailCounter
            } = shift;

            let generalShiftData = {
                Driver,
                DriverID,
                ShiftDate,
                Shift,
                ShiftDetail,
                Truck,
                TruckID,
                Trailer,
                TrailerID,
                ReplacementUnit,
                Yard,
                TruckYard,
                SentMailCounter
            };

            console.log(shift);
            console.log(generalShiftData);

            newShiftInfoDispatch['generalShiftData'] = generalShiftData;
            newShiftInfoDispatch['ordersShiftData'] = [];

            for (let ord of this.shiftOrders[index]) {
                let {
                    Customer,
                    CustomerID,
                    Supplier,
                    SupplierID,
                    LoadNum,
                    LoadNumOrd,
                    LoadingNumber,
                    OrderID,
                    OrderStatus,
                    PreloadOrderID,
                    ShipTo,
                    SpecialInstructions,
                    StationID,
                    Station,
                    StationAddress,
                    StationCity,
                    TerminalID,
                    Terminal,
                    TerminalAddress,
                    TerminalColor
                } = ord;

                newShiftInfoDispatch['ordersShiftData'].push({
                    generalOrderData: {
                        Customer,
                        CustomerID,
                        Supplier,
                        SupplierID,
                        LoadNum,
                        LoadNumOrd,
                        LoadingNumber,
                        OrderID,
                        OrderStatus,
                        PreloadOrderID,
                        ShipTo,
                        SpecialInstructions,
                        StationID,
                        Station,
                        StationAddress,
                        StationCity,
                        TerminalID,
                        Terminal,
                        TerminalAddress,
                        TerminalColor
                    },
                    orderProductData: []
                });
            }

            return newShiftInfoDispatch;
        },
        loadOrderShift: async function(
            shiftDetail,
            index,
            invocationOrigin = ''
        ) {
            this.shifts[index].View = false;
            this.shiftOrders[index].length = 0;
            await axios
                .get('order/shift/' + shiftDetail)
                .then(async response => {
                    console.log(response.data);
                    this.shiftOrders[index] = response.data;

                    if (
                        invocationOrigin != 'updateActiveOrder' ||
                        invocationOrigin !=
                            'onFinalizeCurrentOrderInProgressClose' ||
                        invocationOrigin != 'endOrder' ||
                        invocationOrigin != 'onEditOrderClose' ||
                        invocationOrigin != 'onPreloadOrderToShiftClose' ||
                        invocationOrigin != 'onShiftSummaryClose' ||
                        invocationOrigin != 'preloadOrderInterface' ||
                        invocationOrigin != 'unpreloadOrderInterface' ||
                        invocationOrigin != 'updateFor' ||
                        invocationOrigin != 'setShortLoad'
                    ) {
                        this.AlterOrders = false;
                        this.idxAdd = 0;
                        this.idxRemv = 0;
                    }

                    this.shifts[index].View = true;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
    }
};
</script>
